import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import Home from "../pages/home";
import About from "../pages/about";
import Products from "../pages/products";
import ProductDetail from "../pages/ProductDetail";
import Contact from "../pages/contact";
import Manufacturing from "../pages/manufacturing";
import Trading from "../pages/trading";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { path: "", element: <Home /> },
      { path: "about", element: <About /> },
      { path: "products", element: <Products /> },
      { path: "products/:categorySlug/:index", element: <ProductDetail /> },
      { path: "contact", element: <Contact /> },
      { path: "services/manufacturing", element: <Manufacturing /> },
      { path: "services/trading", element: <Trading /> },
    ],
  },
]);

export default router;
